<template>
  <footer class="footer">
    <div class="container">
      <div class="block">
        <router-link :to="{ name: 'Maps', params: { lang: $route.params.lang }}" class="title">
          <div class="block__icon">
            <i class="fa fa-map" aria-hidden="true"></i>
          </div>
          <h1 class="block__title">{{ $t('map') }}</h1>
        </router-link>
        <router-link :to="{ name: 'Home', params: { lang: $route.params.lang }}" class="title">
          <div class="block__icon">
            <i class="fa fa-university" aria-hidden="true"></i>
          </div>
          <h1 class="block__title">{{ $t('organization') }}</h1>
        </router-link>
        <router-link :to="{ name: 'Profil', params: { lang: $route.params.lang }}" class="title">
          <div class="block__icon">
            <i class="fa fa-address-card" aria-hidden="true"></i>
          </div>
          <h1 class="block__title">{{ $t('profile') }}</h1>
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data () {
    return {
      name: ''
    }
  },
  mounted() {
    // this.name = window.MY_CONFIG_EASYQ.nameOrganization;
  }
}
</script>
